import { createContext, useContext } from "react";

export type WATeamScheduleContentType =
  | "DAILY_WITH_SUMMARY"
  | "DAILY"
  | "WEEKLY"
  | "MONTHLY";

type WATeamScheduleContextT = {
  teamId: string | null;
  setTeamId(teamId: string | null): void;
  roleIds: string[];
  setRoleIds(roleIds: string[]): void;
  withoutRoleSelected: boolean;
  setWithoutRoleSelected(v: boolean): void;
  contentType: WATeamScheduleContentType;
  setContentType: (contentType: WATeamScheduleContentType) => void;
};

export const WATeamScheduleContext = createContext<WATeamScheduleContextT>({
  teamId: null,
  setTeamId: () => {},
  roleIds: [],
  setRoleIds: () => {},
  withoutRoleSelected: false,
  setWithoutRoleSelected: () => {},
  contentType: "DAILY_WITH_SUMMARY",
  setContentType: () => {},
});

export function useWATeamScheduleContext() {
  return useContext(WATeamScheduleContext);
}
